import React,{Component} from 'react';
import PropTypes from 'prop-types';
import isEqual from 'lodash/isEqual';
import isObject from 'lodash/isObject';
import cloneDeep  from 'lodash/cloneDeep';

import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import FormControlLabel from '@mui/material/FormControlLabel';
import  FormHelperText from '@mui/material/FormHelperText';

import Typography from '@mui/material/Typography';

import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import InputLabel from '@mui/material/InputLabel';
import ListItemText from '@mui/material/ListItemText';
import Checkbox  from './Checkbox';
import AuthContext from "./auth/Context";
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  slotProps:{
    paper:{
      style: {
        maxHeight: ITEM_HEIGHT * 8 + ITEM_PADDING_TOP,
        //width: 250,
      }
    }
  },
  sx: { zIndex: (theme) => theme.zIndex.modal + 9999 }
};

class MyPicker extends Component {
  constructor(props){
    super(props);
    this.state={
      value:cloneDeep(this.props.value),
      items:[],
      load:1
    }
    this._all_ =null;
    this.masterData = cloneDeep(this.props.masterData||{});
    this.getCondition = this.getCondition.bind(this);
  }
  async getCondition(_condition){
    if(!_condition) _condition = this.props.condition;
    let condition;
    if(_condition){
      if(_condition && _condition.then){
        condition = await _condition;
      }else{
        if(typeof(_condition)==="object"){
          condition = _condition;
        }else{
          try{
            condition = JSON.parse(_condition);
          }catch(e){console.error(e.message,_condition)}
        }
      }
    }
    return condition;
  }
  async componentDidMount(){
    this._condition = await this.getCondition(this.props.condition);
    this.fetchData();
  }
  shouldComponentUpdate(newProps,newStates){
    this.checkCondition = false;
    if((this.props.condition || newProps.condition) && !isEqual(this.masterData,(newProps.masterData||{}))){
      this.checkCondition = true;
      this.masterData = cloneDeep(newProps.masterData||{});
      return true;
    } 
    if(newStates.load!==this.state.load) return true;
    if(!isEqual(newProps.value,this.state.value)) return true;
    if(!isEqual(newStates.value,this.state.value)) return true;
    return false;
  }
  async componentDidUpdate(oldProps,oldStates){
    const multiple = this.props.multiple || this.props.dataType=="Array";
    if(this.checkCondition){
      let oldCondition = this._condition; //oldProps.condition;
      let newCondition = await this.getCondition(this.props.condition);
      if(!isEqual(newCondition,oldCondition)){
        this._condition = newCondition;
        await this.fetchData(async()=>{
          let value = cloneDeep(this.props.value);
          let value_is_not_valid = false;
          if(value && !multiple){
            let item = await this.getItem(value);
            if(!item){
              value_is_not_valid = true;
              value = null;
            } 
          }
          this.setState({value,load:this.state.load+1},()=>{
            if(value_is_not_valid && this.props.onValueChanged){
              this.props.onValueChanged(null,null,{});
            }
          });
        });
        return;
      }
    }
    if(!isEqual(oldStates.value,this.props.value)){
      //console.log("check new value of options","props:",this.props.value,"old props:",oldProps.value,"new states:",this.state.value,this.props.valueField);
      let value = cloneDeep(this.props.value);
      let value_is_not_valid = false;
      if(value && !multiple){
        let item = await this.getItem(value);
        if(!item){
          value_is_not_valid = true;
          value = null;
        }
      }
      this.setState({value,load:this.state.load+1},()=>{
        if(value_is_not_valid && this.props.onValueChanged){
          this.props.onValueChanged(null,null,{});
        }
      });
    }
  }
  async fetchData(callback){
    let items;
    if(typeof(this.props.items)==="function"){
      try{
        let condition = this._condition||{};
        items = await this.props.items({...condition,status:true},{onlineCallback:(e,rs,response)=>{
          if(e) return console.error("error get online data",e);
          try{
            const new_items = typeof(rs)=="object"?rs:JSON.parse(rs);
            
            if(!isEqual(new_items,this.state.items)){
              //console.log("picker: set new items",{new_items,rs,response});
              this.setState({items:new_items,load:this.state.load+1});
            }
          }catch(e){
            console.error("error parse json",rs,e);
          }
        }});

      }catch(e){
        return console.error(e.message);
      }
    }else{
      items = this.props.items;
    }
    if(items.forEach){
      this.setState({items:items,load:this.state.load+1},callback);
    }else{
      this.setState({items:[],load:this.state.load+1},callback);
      console.error("Items must be an array or an async function which return an array")
    }
  }
  async getItem(value){
    if(!value && value !=0) return;
    let item = this.state.items.find(item=> isEqual(item[this.props.valueField],value));
    if(!item && typeof(this.props.items)==="function"){
      try{
        let condition = this._condition||{};
        let items = await this.props.items({...condition,[this.props.valueField]:value});
        if(items.length>0){
          item = items[0];
        }
      }catch(e){
        console.error(e.message);
      }
    }
    return item;
  }
  handleValueChanged(value){
    const multiple = this.props.multiple || this.props.dataType=="Array";
    if(multiple){
      let _values = (typeof value === 'string' ? value.split(',') : value);
      this.setState({value:_values},()=>{
        if(this.props.onValueChanged){
          let items =_values.map(v=> (this.state.items||[]).find(item=>isEqual(item[this.props.valueField],v))||{})
          let labels = items.map(v=>v[this.props.labelField||this.props.valueField]);
          this.props.onValueChanged(_values,labels,items);
        }
      })
    }else{
      let _value =(value==="--"?null:value);
      this.setState({value:_value},()=>{
        if(this.props.onValueChanged){
          let item = (this.state.items||[]).find(item=>isEqual(item[this.props.valueField],_value));
          let label = (item && this.props.labelField)?item[this.props.labelField]:"--";
          this.props.onValueChanged(_value,label,item);
        }
      })
    }
  }
  render() {
    let {items,value} = this.state;
    const multiple = this.props.multiple || this.props.dataType=="Array";
    //default style
    let defaultInputProps = (this.props.mediaQueryMatches || this.context.config?.isMobile)?{
      disableUnderline: true,
      style:{
        maxWidth:this.props.inline?200:undefined,
        padding:5,
        border:"1px solid #B9B9B9",
        borderRadius:3,
        display:"flex",
        flexDirection:"row",
        alignItems:"center",
        backgroundColor:this.props.disabled || this.props.readOnly?'#f5f5f5':undefined
      }
    }:{};
    let InputProps = {...defaultInputProps,...this.props.InputProps}

    const variant= this.props.variant;

    if(items.length===0 && value) items=[{[this.props.valueField]:value}];
    let _value = value;
    /*Convert kiểu dữ liệu
    if(this.props.dataType=="String"){
      _value = _value!=undefined && _value!=null?_value.toString():_value;
      items.forEach(item=>{
        let v_item = item[this.props.valueField];
        item[this.props.valueField] = v_item!=undefined && v_item!=null?item[this.props.valueField].toString():v_item;
      })
    }
    if(this.props.dataType=="Number"){
      try{
        _value = _value!=undefined && _value!=null?Number(_value):_value;
      }catch(e){
        console.Error(`[Picker] không thể convert '${_value}' sang ${this.props.dataType}`)
      }
      items.forEach(item=>{
        let v_item = item[this.props.valueField];
        item[this.props.valueField] = v_item!=undefined && v_item!=null?Number(item[this.props.valueField]):v_item;
      })
    }*/
    //fixed value
    if(multiple){
      _value = _value||[];
    }else{
      if(!_value && _value!=0) _value ="--";
      //add empty item
      if(!this.props.isRadio && !this.props.required){
        let emptyItem = {[this.props.valueField]:"--"};
        if(this.props.labelField){
          emptyItem[this.props.labelField] = "<Trống>"
        }
        items=items.concat([emptyItem]);
      }
    }
    //radio control
    if(this.props.isRadio && !multiple){
      return (
        <FormControl margin={this.props.margin} readOnly={this.props.disabled || this.props.readOnly}>
          <FormLabel>{this.props.inputLabel}</FormLabel>
          <RadioGroup
            value={_value}
            readOnly={this.props.disabled || this.props.readOnly}
            onChange={event=>this.handleValueChanged(event.target.value)}
            row={this.props.radioRow!=false || this.props.inline}
          >
            {items.map((tt,index)=>{
              let value = tt[this.props.valueField]
              return (
                <FormControlLabel key={index.toString()} value={value} control={<Radio size="medium" color={this.context.config.primaryColor} />} label={this.context.apis.getLabel(tt[this.props.labelField||this.props.valueField]||"--")} />
              )
            })}
          </RadioGroup>
        </FormControl>
      )
    }
    //select
    if(!this.props.inputLabel || this.props.inline){
      //console.log("render Picker:",{field:this.props.valueField,dataType:this.props.dataType,multiple});
      return (
        <Select
          id={this.props.id}
          variant={variant}
          fullWidth ={this.props.fullWidth}
          required={this.props.required}
          margin={this.props.margin}
          multiple = {multiple}
          native={false}
          displayEmpty = {true}
          MenuProps={MenuProps}
          
          
          renderValue ={value=>{
            //render array
            if(Array.isArray(value)){
              if(value.length==0) return this.props.inputLabel||"--";
              let labels = value.map(v=>{
                let item = items.find(i=>isEqual(i[this.props.valueField],v));
                if(item) return item[this.props.labelField||this.props.valueField];
                return v;
              })
              return labels.join(", ");
            }
            //render signle value
            if(value=="--"){
              if(this.props.inline){
                return this.props.inputLabel||"--";
              }else{
                return "--";
              }
            }
            let label;
            let item = items.find(i=>isEqual(i[this.props.valueField],value));
            if(item){
              label =  item[this.props.labelField||this.props.valueField];
            }else{
              label =  value;
            }
            if(isObject(label)){
              label = JSON.stringify(label);
            }
            return (label||"").toString();
          }}

          placeholder={this.props.inputLabel}
          
          value={_value}
          disabled={this.props.disabled}
          InputProps={InputProps}
          inputProps={InputProps}

          style={(InputProps||{}).style}

          readOnly={this.props.readOnly}
          onChange={event=>this.handleValueChanged(event.target.value)}
          disableUnderline={(InputProps||{}).disableUnderline}
        >
          {items.map((tt,index)=>{
            let value = tt[this.props.valueField]
            let label = tt[this.props.labelField||this.props.valueField];
            if(!value && value!=0){
              value ="--";
            }
            if(value=="--") label = "<Trống>";

            let paddingLeft = 15 + 15 * ((tt.bac||1)-1);
            let fontWeight = (tt.loai_nh===0?"bold":undefined);

            let checked;
            if(multiple){
              checked = (this.state.value||[]).find(i=>isEqual(i,value));
            }

            return (
              <MenuItem key={index.toString()} value={value} style={{paddingLeft,fontWeight}}>
                {!!multiple &&  <Checkbox value={checked} label={this.context.apis.getLabel(label)}/>}
                {!multiple && <ListItemText primary={this.context.apis.getLabel(label)} />}
              </MenuItem>
            )
          })}
        </Select>
      )
    }
    return (
      <FormControl variant={variant} margin={this.props.margin || "normal"} fullWidth required={this.props.required}>
          {!this.props.mediaQueryMatches &&  <InputLabel shrink={true}>{this.props.inputLabel}</InputLabel>}
          {this.props.mediaQueryMatches &&  <Typography component="div" variant="caption" class="InputLabel">
            <span dangerouslySetInnerHTML={{__html: this.props.inputLabel + (this.props.required?' *':'')}}/>
          </Typography>}
          
          <Select
            id={this.props.id}
            fullWidth ={this.props.fullWidth}
            required={this.props.required}
            value={_value}
            multiple = {multiple}
            native={false}
            displayEmpty = {true}
            MenuProps={MenuProps}
            renderValue ={value=>{
              //render array
              if(Array.isArray(value)){
                if(value.length==0) return "--";
                let labels = value.map(v=>{
                  let item = items.find(i=>isEqual(i[this.props.valueField],v));
                  if(item) return item[this.props.labelField||this.props.valueField];
                  return v;
                })
                return labels.join(", ");
              }
              //render signle value
              if(value=="--"){
                return "--";
              } 
              let label;
              let item = items.find(i=>isEqual(i[this.props.valueField],value));
              //console.log("[picker] render value",value,item);
              if(item){
                label =  item[this.props.labelField||this.props.valueField];
              }else{
                label =  value;
              }
              if(isObject(label)){
                label = JSON.stringify(label);
              }
              return (label||"").toString();
            }}
            
            
            label={this.props.inputLabel}
          
            disabled={this.props.disabled}
            InputProps={InputProps}
            inputProps={InputProps}
            style={(InputProps||{}).style}

            disableUnderline={(InputProps||{}).disableUnderline}
            readOnly={this.props.readOnly}
            onChange={event=>this.handleValueChanged(event.target.value)}
          >
            {items.map((tt,index)=>{
              let value = tt[this.props.valueField]
              if(!value && value!=0) value ="--";
              let label = tt[this.props.labelField||this.props.valueField];

              /*if(this.props.valueField!=="_id" && tt[this.props.valueField] && typeof(tt[this.props.valueField])!="object"  && this.props.labelField && this.props.valueField!=this.props.labelField && (tt[this.props.valueField]||"").toString().toUpperCase() !=(label||"").toString().toUpperCase()  ){
                label = `${tt[this.props.valueField]}: ${label}`
              }*/

              if(value=="--") label = "<Trống>";


              let checked;
              if(multiple){
                checked = (this.state.value||[]).find(i=>isEqual(i,value));
              }
            
              let paddingLeft = 15 + 15 * ((tt.bac||1)-1);
              let fontWeight = (tt.loai_nh===0?"bold":undefined);
              
              return (
                <MenuItem key={index.toString()} value={value}  style={{paddingLeft,fontWeight}}>
                  {!!multiple &&  <Checkbox value={checked} label={this.context.apis.getLabel(label)}  />}
                  {!multiple && <ListItemText primary={this.context.apis.getLabel(label)} />}
                </MenuItem>
              )
            })}
          </Select>
          {!!this.props.helperText && <FormHelperText>{this.props.helperText}</FormHelperText>}
      </FormControl>
    )
  }
}
MyPicker.contextType = AuthContext;
MyPicker.propTypes={
  label:PropTypes.string,
  onValueChanged:PropTypes.func,
  dataType:PropTypes.string,
  value:PropTypes.any,
  required:PropTypes.bool,
  disabled:PropTypes.bool,
  readOnly:PropTypes.bool,
  fullWidth:PropTypes.bool,
  multiple:PropTypes.bool,
  isRadio:PropTypes.bool,
  radioRow:PropTypes.bool,
  inline:PropTypes.bool,//inline form, Tất cả các field sẽ nằm trên một dòng
  helperText:PropTypes.string,
  valueField:PropTypes.string.isRequired,
  labelField:PropTypes.string,
  inputLabel:PropTypes.string,
  id:PropTypes.string,
  condition:PropTypes.any,
  InputProps:PropTypes.object,
  mediaQueryMatches:PropTypes.bool,
  items:PropTypes.any.isRequired//array or url
}
export default MyPicker;
